import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../Redux";
import DynamicTable from "../../Components/DynamicTable";
import { useHistory } from "react-router-dom";

const Promotions = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const setFormState = (state) => {
    dispatch(
      actions.setFormState({
        formName: "promo_data_form_type",
        formState: state,
      })
    );
  };
  const promotionsData = useSelector(
    (state) => state?.settingReducer?.promotionsData
  );

  useEffect(() => {
    dispatch(actions.getPromotions({ status: 1 }));
    setFormState("add");
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0 my-4">
            <div className="row mx-0">
              <div className="container px-0 top-header-sec">
                <DynamicTable
                  tableInfo={{
                    title: "Promotions List",

                    actions: true,
                    editable: true,
                    deleteable: false,
                    activable: true,

                    addButtonTitle: "Add Account",
                    showSearch: true,
                    showUpperAddButton: true,
                    showLowerAddButton: false,

                    tableTabsInfo: [
                      {
                        name: "active",
                        runOnClick: () => {
                          dispatch(actions.getPromotions({ status: 1 }));
                        },
                        active: true,
                      },
                      {
                        name: "inactive",
                        runOnClick: () => {
                          dispatch(actions.getPromotions({ status: 2 }));
                        },
                        active: false,
                      },
                    ],

                    headings: [
                      "Promotion ID",
                      "Promotion Name",
                      "Promotion Group",
                      "Status",
                      "Promotion Type",
                      "Qualification Type",
                      "Promotion Code",
                      "Last Pushdown Update",
                      "Actions?",
                    ],
                    dataArray: promotionsData?.promotions,
                    dataKeys: [
                      "id",
                      "promotion_name",
                      "PromotionGroup",
                      "status",
                      "type",
                      "qualification_type",
                      "code",
                      "last_pushdown_update",
                    ],
                    editKey: "id",

                    activeKeyValuePairs: [
                      { key: "id", value: "id" },
                      { key: "status", value: "status" },
                    ],
                    editOnClick: function (key) {
                      setFormState("edit");
                      dispatch(actions.getEditPromotionData({ id: key }));
                      history.push("/menu/promotions/new-promotion");

                      console.log(key);
                    },
                    addOnClick: function () {
                      console.log("jiiiiiii");
                      history.push("/menu/promotions/new-promotion");
                    },
                    activeOnClick: function (activeKeyValuePairs) {
                      dispatch(actions.deletePromotion(activeKeyValuePairs));
                    },
                  }}
                />
              </div>
            </div>

            <div class="row mx-0 mt-3">
              <div className="container px-0">
                <DynamicTable
                  tableInfo={{
                    title: "History",

                    // actions: true,
                    // editable: true,
                    // deleteable: false,
                    // activable: true,

                    // addButtonTitle: "Add Account",
                    // tableTabs: true,
                    showSearch: false,
                    showUpperAddButton: false,
                    showLowerAddButton: false,
                    // tableTabsInfo: [
                    //   { name: "active", runOnClick: () => {}, active: true },
                    //   { name: "inactive", runOnClick: () => {}, active: false },
                    // ],

                    headings: [
                      "Start",
                      "End",
                      "Field",
                      "Value",
                      "	Replacement Value",
                    ],
                    dataArray: promotionsData?.history,
                    dataKeys: [
                      "start",
                      "end",
                      "field",
                      "value",
                      "replacement_value",
                    ],
                    editKey: "id",
                    // deleteKeyValuePairs: [
                    //   { key: "id", value: "id" },
                    //   { key: "status", value: "status" },
                    // ],
                    activeKeyValuePairs: [
                      { key: "id", value: "id" },
                      { key: "status", value: "status" },
                    ],
                    editOnClick: function (key) {
                      // setAddBankingModalState(true);
                      // updateEditBankingModalState(key);
                      console.log(key);
                    },
                    // addOnClick: function () {
                    //   setAddBankingModalState(true);
                    // },
                    // deleteOnClick: function (deleteKeyValuePairs) {
                    //   dispatch(actions.deletePromotion(deleteKeyValuePairs));
                    // },
                    activeOnClick: function (activeKeyValuePairs) {
                      dispatch(actions.deletePromotion(activeKeyValuePairs));
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Promotions;
